var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
         'odr-g-size-s-m': _vm.dimensionsMode !== 'l',
         'odr-g-size-l': _vm.dimensionsMode === 'l',
         'odr-g-size-m': _vm.dimensionsMode === 'm',
         'odr-g-size-s': _vm.dimensionsMode === 's',
         'odr-g-size-xs': _vm.dimensionsMode === 'xs',
         'odr-g-widget-rtl': _vm.$root.appConfig.rtl
     },staticStyle:{"height":"100% !important"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }